<template>
  <main>
    <div class="relative bg-white overflow-hidden">
      <div class="max-w-screen-xl mx-auto">
        <div class="relative z-10 pb-8 bg-white sm:pb-16 md:pb-20 lg:max-w-2xl lg:w-full lg:pb-28 xl:pb-32">
          <svg class="hidden lg:block absolute right-0 inset-y-0 h-full w-48 text-white transform translate-x-1/2" fill="currentColor" viewBox="0 0 100 100" preserveAspectRatio="none">
            <polygon points="50,0 100,0 50,100 0,100" />
          </svg>

          <div class="relative pt-6 px-4 sm:px-6 lg:px-8">
            <nav class="relative flex items-center justify-between sm:h-10 lg:justify-start">
              <div class="flex items-center flex-grow flex-shrink-0 lg:flex-grow-0">
                <div class="flex items-center justify-between w-full md:w-auto">
                  <a target="_blank" href="https://phaneroo.org/">
                    <PhanerooLogo class="h-8 w-auto sm:h-10"  />
                  </a>
                  <div class="-mr-2 flex items-center md:hidden">
                    <!-- Side nave toggle button -->
                    <button @click="isMobileMenuOpen = true" type="button" class="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 focus:text-gray-500 transition duration-150 ease-in-out" id="main-menu" aria-label="Main menu" aria-haspopup="true">
                      <svg class="h-6 w-6" stroke="currentColor" fill="none" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
              <div class="hidden md:block md:ml-10 md:pr-4">
                <a target="_blank" href="https://phaneroo.org/contact-us/" class="font-medium text-gray-500 hover:text-gray-900 transition duration-150 ease-in-out">Contact</a>
                <!-- <router-link to="/admin/login" class="ml-8 font-medium text-phaneroo-600 hover:text-phaneroo-900 transition duration-150 ease-in-out">Log in</router-link> -->
              </div>
            </nav>
          </div>

          <!--
            Mobile menu, show/hide based on open status
          -->
          <transition
            enter-class="opacity-0 scale-95"
            enter-active-class="duration-150 ease-out"
            enter-to-class="opacity-100 scale-100"
            leave-class="opacity-100 scale-100"
            leave-active-class="duration-100 ease-in"
            leave-to-class="opacity-0 scale-95"
          >
            <div v-show="isMobileMenuOpen" class="absolute top-0 inset-x-0 p-2 transition transform origin-top-right md:hidden">
              <div class="rounded-lg shadow-md">
                <div class="rounded-lg bg-white shadow-xs overflow-hidden" role="menu" aria-orientation="vertical" aria-labelledby="main-menu">
                  <div class="px-5 pt-4 flex items-center justify-between">
                    <div>
                      <PhanerooLogo class="h-8 w-auto sm:h-10"  />
                    </div>
                    <div class="-mr-2">
                      <!-- Close sidenav button -->
                      <button @click="isMobileMenuOpen = false" type="button" class="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 focus:text-gray-500 transition duration-150 ease-in-out" aria-label="Close menu">
                        <svg class="h-6 w-6" stroke="currentColor" fill="none" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                      </button>
                    </div>
                  </div>
                  <div class="px-2 pt-2 pb-3">
                    <a target="_blank" href="https://phaneroo.org/contact-us/" class="mt-1 block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:text-gray-900 focus:bg-gray-50 transition duration-150 ease-in-out" role="menuitem">Contact</a>
                  </div>
                  <!-- <div>
                    <router-link to="/admin/login" class="block w-full px-5 py-3 text-center font-medium text-phaneroo-600 bg-gray-50 hover:bg-gray-100 hover:text-phaneroo-700 focus:outline-none focus:bg-gray-100 focus:text-phaneroo-700 transition duration-150 ease-in-out" role="menuitem">
                      Log in
                    </router-link>
                  </div> -->
                </div>
              </div>
            </div>
          </transition>

          <main class="mt-10 mx-auto max-w-screen-xl px-4 sm:mt-12 sm:px-6 md:mt-16 lg:mt-20 lg:px-8 xl:mt-28">
            <div class="sm:text-center lg:text-left">
              <h2 class="text-4xl text-phaneroo-500 tracking-tight leading-10 font-extrabold sm:text-5xl sm:leading-none md:text-6xl">
                Phaneroo
                <br class="xl:hidden">
                <span class="text-gray-800">Prayer Requests</span>
              </h2>
              <p class="mt-3 text-base text-gray-500 sm:mt-5 sm:text-lg sm:max-w-xl sm:mx-auto md:mt-5 md:text-xl lg:mx-0">
                Effectual prayer makes power available. Let us stand with you.
              </p>
              <div class="mt-5 sm:mt-8 sm:flex sm:justify-center lg:justify-start">
                <b-button @click="$router.push('/?newprayerrequest=true')" type="is-primary" class="shadow-lg mr-3">
                  Submit Prayer Request
                </b-button>
                <b-button tag="a" href="https://phaneroo.org/testimonies" target="_blank" rel="noreferrer noopener" type="is-outline" class="shadow-lg">
                  Submit Testimony
                </b-button>
              </div>
            </div>
          </main>
        </div>
      </div>
      <div class="lg:absolute lg:inset-y-0 lg:right-0 lg:w-1/2">
        <!-- <img class="h-56 w-full object-cover sm:h-72 md:h-96 lg:w-full lg:h-full" src="https://images.unsplash.com/photo-1551434678-e076c223a692?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2850&q=80" alt=""> -->
        <img class="h-56 w-full object-cover sm:h-72 md:h-96 lg:w-full lg:h-full" src="@/assets/images/phaneroo/hero-photo-apgl.jpg" alt="Pastor praying for man">
      </div>
      <b-modal custom-class="max-h-auto" :active.sync="showPrayerRequestForm" @close="$router.push('/')" :width="640" scroll="keep">
        <PrayerRequestForm @close="$router.push('/')" />
      </b-modal>
      <b-modal custom-class="max-h-auto" :active.sync="showTestimonyForm" @close="$router.push('/')" :width="640" scroll="keep">
        <TestimoniesForm @close="$router.push('/')" />
      </b-modal>
    </div>
    <ScriptureQuote />
    <PhanerooFooter />
  </main>
</template>

<script>
import PhanerooLogo from '@/components/logo'
import PrayerRequestForm from '@/components/forms/prayer-request-form'
import TestimoniesForm from '@/components/forms/testimonies-form'
import PhanerooFooter from '@/components/marketing/footer'
import ScriptureQuote from '@/components/marketing/scripture-quote'

export default {
  name: 'Home2',
  components: {
    PhanerooLogo,
    PrayerRequestForm,
    TestimoniesForm,
    PhanerooFooter,
    ScriptureQuote
  },
  data () {
    return {
      isMobileMenuOpen: false,
      showPrayerRequestForm: false,
      showTestimonyForm: false
    }
  },
  async created () {
    try {
      /**
       * Get all prayer request categories
       */
      await this.$store.dispatch('categories/getCategories')
    } catch (error) {
      this.$logger.error('Error fetching prayer request categories', error)
      this.$sentry.captureException(error)
    }

    if (this.$route.query.newprayerrequest) {
      this.showPrayerRequestForm = true
    } else if (this.$route.query.newtestimony) {
      this.showTestimonyForm = true
    }
  },
  watch: {
    '$route.query.newprayerrequest': {
      immediate: true,
      handler (newVal) {
        if (newVal) {
          this.showPrayerRequestForm = true
        } else {
          this.showPrayerRequestForm = false
        }
      }
    },
    '$route.query.newtestimony': {
      immediate: true,
      handler (newVal) {
        if (newVal) {
          this.showTestimonyForm = true
        } else {
          this.showTestimonyForm = false
        }
      }
    }
  },
  methods: {
    closePrayerRequestForm () {
      if (this.$route.query.newprayerrequest) {
        this.$router.push('/')
      }
      this.showPrayerRequestForm = false
    },
    closeTestimonyForm () {
      if (this.$route.query.newtestimony) {
        this.$router.push('/')
      }
      this.showTestimonyForm = false
    }
  }
}
</script>

<style lang="scss">
.modal {
  .modal-content {
    max-height: 100vh;
  }
}
</style>
